import { useEffect, useState } from 'react';
import { briefPiecesJointesFromVente } from '../utils/kkpBriefFichierUtils';
import { suggestBriefWizardStep } from '../utils/kkpVenteBriefUtils';

export function useKkpVenteBriefWizard({ show, vente, initialWizardStep, initialValues = {} }) {
  const [currentStep, setCurrentStep] = useState(0);
  const [savedVente, setSavedVente] = useState(null);
  const [piecesJointes, setPiecesJointes] = useState([]);

  const activeVente = savedVente ?? vente;
  const activeVenteId = activeVente?.id ?? null;

  useEffect(() => {
    if (!show) return;

    setSavedVente(null);

    if (vente) {
      setPiecesJointes(briefPiecesJointesFromVente(vente));
      setCurrentStep(suggestBriefWizardStep(vente, initialWizardStep));
      return;
    }

    setPiecesJointes(briefPiecesJointesFromVente(initialValues));
    setCurrentStep(typeof initialWizardStep === 'number' ? initialWizardStep : 0);
  }, [show, vente, initialWizardStep, initialValues]);

  const shouldCloseAfterCreate = (step) => step !== 1;

  return {
    currentStep,
    setCurrentStep,
    savedVente,
    setSavedVente,
    piecesJointes,
    setPiecesJointes,
    activeVente,
    activeVenteId,
    shouldCloseAfterCreate,
  };
}
